export default {
    setLocations(state, payload){
        state.pickupLocations = payload.pickupLocations;
        state.corporateLocations = payload.corporateLocations;
    }
}